import { useNavigate } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";
import { useBranding } from "@/contexts/BrandingContext";

export const WORKSPACE_KEY = "nts-workspace";

export const WorkspaceSwitch = ({ isT4R, collapsed }) => {
  const navigate = useNavigate();
  const { short_name, lms_name, lms_short_name } = useBranding();
  const go = (ws) => {
    localStorage.setItem(WORKSPACE_KEY, ws);
    navigate(ws === "t4r" ? "/t4r" : "/");
  };

  if (collapsed) {
    return (
      <button
        onClick={() => go(isT4R ? "nts" : "t4r")}
        title={isT4R ? `Switch to ${short_name || "CRM"}` : `Switch to ${lms_name}`}
        className={`mx-auto flex h-8 w-8 items-center justify-center rounded-full transition-colors ${isT4R ? "bg-green-500 text-[#0B2418] hover:bg-green-400" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}
        data-testid="workspace-switch-compact"
      >
        <ArrowLeftRight size={15} />
      </button>
    );
  }

  const btn = (active) =>
    `relative z-10 py-1.5 rounded-full transition-colors duration-200 ${active ? (isT4R ? "text-[#0B2418]" : "text-slate-900") : (isT4R ? "text-green-100/70 hover:text-white" : "text-slate-500 hover:text-slate-800")}`;

  return (
    <div className={`relative grid grid-cols-2 p-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${isT4R ? "bg-white/10" : "bg-slate-100"}`} data-testid="workspace-switch">
      <span
        aria-hidden
        className={`absolute top-1 bottom-1 left-1 w-[calc(50%-4px)] rounded-full shadow-sm transition-transform duration-300 ease-out ${isT4R ? "translate-x-full bg-green-500" : "translate-x-0 bg-white"}`}
      />
      <button onClick={() => isT4R && go("nts")} className={btn(!isT4R)} aria-pressed={!isT4R} data-testid="workspace-switch-nts">{short_name || "CRM"}</button>
      <button onClick={() => !isT4R && go("t4r")} className={btn(isT4R)} aria-pressed={isT4R} data-testid="workspace-switch-t4r">{lms_short_name || "LMS"}</button>
    </div>
  );
};
